import { ThemeProvider } from "styled-components";
import { useChart } from "./hooks/useChart";
import { Home } from "./screens/Home";
import { useCustomTheme } from "./hooks/useCustomTheme";
import { ChartStatus } from "./store/chart";
import "./App.css";
import { ROOT_ID } from "./utils/constants";

function App() {
  const theme = useCustomTheme();
  const { status } = useChart();

  return (
    <ThemeProvider theme={theme}>
      {[ChartStatus.INITIAL, ChartStatus.LOADING].includes(status) ? (
        <div>Loading...</div>
      ) : (
        <Home />
      )}
      <div id={`${ROOT_ID}_tooltip`} />
    </ThemeProvider>
  );
}

export default App;
